import {GET_DATA_SUCCESS, GET_DATA_ERROR, GET_DATA_REQUEST} from '../actions/ProfitAction'; // Import our actions
const initialState = {
  daily_profit: {},
  isFetchingProfit: true, // Default to fetching..
  error: null
};


const ProfitReducer = function (state = initialState, action){
  switch (action.type) {
    case GET_DATA_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case GET_DATA_SUCCESS:
      return {
        ...state,
        daily_profit: action.daily_profit,
        isFetchingProfit: false
      };

    case GET_DATA_ERROR:
      console.log('Error: ', action.error);
      return {
        ...state,
        error: action.error,
        isFetching: false
      };
    default:
      return state;
  }
};

export default ProfitReducer